import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "pt-2 pl-4"
}

import { computed } from 'vue'
import responseCourse from '@/types/requests/course';
import i18n from '@/lang/i18n';

const MAX_REGISTER_COURSE_COUNT = 20;


export default /*@__PURE__*/_defineComponent({
  __name: 'CourseForm',
  props: {
    modelValue: {},
    operationOfficeId: {},
    errorMessages: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

function addCourse(index: number) {
  if (modelValue.value.length >= MAX_REGISTER_COURSE_COUNT) {
    return;
  }
  modelValue.value.splice(index + 1, 0, {
    id: null,
    operation_office_id: props.operationOfficeId ?? null,
    name: '',
  });
}

function removeCourse(index: number) {
  if (modelValue.value.length <= 1) {
    return;
  }
  modelValue.value.splice(index, 1);
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelValue.value, (course, index) => {
      return (_openBlock(), _createBlock(_component_v_row, {
        key: index,
        class: "select-form pl-4 pr-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: props.windowInnerWidth > 800 ? 2 : 3
          }, {
            default: _withCtx(() => [
              (index == 0)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.courseName')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["cols"]),
          _createVNode(_component_v_col, {
            cols: props.windowInnerWidth > 800 ? 6 : 9,
            class: "d-flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: modelValue.value[index].name,
                "onUpdate:modelValue": ($event: any) => ((modelValue.value[index].name) = $event),
                "error-messages": props.errorMessages[`courses.${index}.name`],
                class: "mt-0"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages"])
            ]),
            _: 2
          }, 1032, ["cols"]),
          _createVNode(_component_v_col, {
            cols: props.windowInnerWidth > 800 ? 2 : 3,
            class: "d-flex"
          }, {
            default: _withCtx(() => [
              (index == modelValue.value.length - 1 && index != (MAX_REGISTER_COURSE_COUNT - 1))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "mb-1 mr-2",
                    height: "50",
                    color: "blue-darken-2",
                    onClick: ($event: any) => (addCourse(index))
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (modelValue.value.length != 1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    class: "mb-1",
                    height: "50",
                    color: "danger",
                    onClick: ($event: any) => (removeCourse(index))
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("span", {
                        class: "material-symbols-outlined",
                        style: {"color":"white"}
                      }, " delete ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["cols"])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})